import { all } from "redux-saga/effects";
import authSagas from "./auth/saga";
import accountSaga from "./account/saga";
import usersSaga from "./users/saga";
import ordersSaga from "./orders/saga";

export default function* rootSaga(getState) {
  yield all([authSagas(), accountSaga(), usersSaga(), ordersSaga()]);
}
